const reverseMarkers = {
  unbold: 'bold',
  unitalic: 'italic',
  no_strikethrough: 'strikethrough',
  no_underline: 'underline',
};

const getPrepareMarks = (marks) => {
  if (!marks) return {};

  return marks?.reduce((prepareMarksAcc, mark) => {
    const { type, data } = mark;

    if (Object.prototype.hasOwnProperty.call(reverseMarkers, type)) {
      return {
        ...prepareMarksAcc,
        [reverseMarkers[type]]: false,
      };
    }

    if (type === 'color') {
      if (data?.color) {
        return {
          ...prepareMarksAcc,
          color: data.color,
        };
      }

      return prepareMarksAcc;
    }

    return {
      ...prepareMarksAcc,
      [type]: true,
    };
  }, {});
};

export default getPrepareMarks;
